import { Card, HStack, Text, VStack } from '@talos/kyoko';
import type { ReactNode } from 'react';
import type { DisplayOutputItem } from './types';

interface InspectorSectionsRendererProps {
  sections: DisplayOutputItem[];
}

export const InspectorSectionsRenderer = ({ sections }: InspectorSectionsRendererProps) => {
  return (
    <VStack gap="spacing12" w="100%" alignItems="stretch">
      {sections.map(({ sectionTitle, fields }) => (
        <VStack
          data-testid={`instrument-inspector-section-${sectionTitle}`}
          key={sectionTitle}
          gap="spacing2"
          w="100%"
          alignItems="stretch"
        >
          <Card display="flex" flexDirection="column">
            <Text color="colorTextImportant" size="fontSizeMd">
              {sectionTitle}
            </Text>
          </Card>
          <Card
            data-testid="instrument-inspector-section-fields"
            key={sectionTitle}
            display="flex"
            flexDirection="column"
          >
            <VStack gap="spacing8" w="100%" alignItems="stretch">
              {fields.map(({ fieldName, fieldValue }: { fieldName: string; fieldValue: ReactNode }) => (
                <HStack key={fieldName} justifyContent="space-between" gap="spacing16" alignItems="flex-start">
                  <Text data-testid="instrument-inspector-section-field-label" flexShrink={0}>
                    {fieldName}
                  </Text>
                  {fieldValue}
                </HStack>
              ))}
            </VStack>
          </Card>
        </VStack>
      ))}
    </VStack>
  );
};
